import { render, staticRenderFns } from "./productRobot.vue?vue&type=template&id=789756b1&scoped=true&"
import script from "./productRobot.vue?vue&type=script&lang=js&"
export * from "./productRobot.vue?vue&type=script&lang=js&"
import style0 from "./productRobot.vue?vue&type=style&index=0&id=789756b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789756b1",
  null
  
)

export default component.exports